import { Theme, ThemeProvider, useMediaQuery } from '@mui/material';
import WithCampaignMetrics from 'features/campaigns/components/WithCampaignMetrics';
import WithInvoiceMetrics from 'features/invoice/components/WithInvoiceMetrics';
import RequirePrivilege from 'features/user/components/RequirePrivilege';
import config from 'libs/config';
import MiniVariantDrawer from './MiniVariantDrawer';
import TemporaryDrawer from './TemporaryDrawer';

function KampusDrawer() {
  const matchesUpMd = useMediaQuery((theme: Theme) =>
    theme.breakpoints.up('md')
  );

  return (
    <ThemeProvider theme={config.domain.themes[1]}>
      <WithCampaignMetrics />
      <RequirePrivilege requiredPrivileges={['INVOICES_READ']}>
        <WithInvoiceMetrics />
      </RequirePrivilege>
      {matchesUpMd && <MiniVariantDrawer />}
      {!matchesUpMd && <TemporaryDrawer />}
    </ThemeProvider>
  );
}

export default KampusDrawer;
